// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"007f15c7","32":"9be6c7e3","56":"ec0b2196","112":"2a4d131a","216":"3b9b785e","528":"dac615fa","552":"3844b09f","592":"622a21c1","648":"9cfed1eb","748":"ba7e9d54","856":"468bb766","948":"ae5636d8","952":"5d90e787","971":"c60ec89c"}[chunkId] + ".chunk.js";
};